import styled from 'styled-components';

export const CSSFileViewer = styled.div`
    display: flex;
    flex: 1;
    flex-direction: column;
    background-color: ${(props) => (props.theme.color.night2 ? props.theme.color.night2 : '#10162D')}e6;
`;

export const CSSFileViewerHeader = styled.div`
    display: flex;
    align-items: center;
    min-height: 40px;
    padding: 0 32px;
    color: ${(props) => props.theme.color.white};
    background-color: ${(props) => (props.theme.color.night2 ? props.theme.color.night2 : '#10162D')};
    margin-bottom: 24px;
`;

export const CSSFileViewerHeaderContent = styled.div`
    display: flex;
    flex: 1;
    align-items: center;
    justify-content: space-between;
`;

export const CSSFileViewerDownload = styled.a`
    display: flex;
    gap: 8px;
    align-items: center;
    margin-top: 1px;
    
    & * {
      transition: color 0.1s;  
    }

    &:hover {
        text-decoration: none;
        
        *, i:before {
            color: ${({ theme }) => theme.color.white};
        }
    }
}
`;

export const CSSFileViewerFooter = styled.div`
    position: fixed;
    width: 100%;
    bottom: 0;
    display: flex;
    min-height: 40px;
    justify-content: center;
    align-items: center;
    padding: 24px;
    pointer-events: none;
`;

export const CSSFileViewerContent = styled.div`
    flex: 1;
    justify-content: center;
    display: flex;
`;

export const CSSFileViewerContentAudio = styled.div`
    margin: auto;
    display: flex;
    justify-content: center;
    flex-direction: column;
    gap: 24px;
`;

export const CSSFileViewerApplicationContent = styled.div`
    margin: auto;
    display: flex;
    justify-content: center;
    flex-direction: column;
    gap: 24px;
`;

export const CSSFileViewerApplicationContentWrapper = styled.div`
    max-width: 120px;
    min-width: 120px;
    margin: auto;
    img {
        max-width: 100%;
    }
`;

export const CSSFileViewerOptions = styled.div`
    display: flex;
    gap: 12px;
    justify-content: center;
`;

export const CSSFileViewerContentImage = styled.div`
    flex: 1;
    justify-content: center;
    display: flex;
    max-width: 100%;
    max-height: calc(100vh - 210px);
    margin: 0 auto;
`;

export const CSSFileViewerContentVideo = styled.div`
    flex: 1;
    justify-content: center;
    display: flex;
    video {
        max-width: 100%;
        max-height: calc(100vh - 210px);
        margin: 0 auto;
    }
`;

export const CSSFileViewerImageBackground = styled.div<{ uri: string }>`
    border-radius: 8px;
    width: 100%;
    height: 100%;
    background-position: top center;
    background-size: cover;
    background-repeat: no-repeat;
    background-image: url('${(props) => props.uri}');
`;

const ARROW_SIZE = 40;

export const CSSFileViewerArrowsButton = styled.button`
    pointer-events: all;
`;

export const CSSFileViewerStep = styled.div`
    color: ${(props) => props.theme.color.white};
`;

export const CSSFileViewerArrows = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;

    .right,
    .left {
        transition: all 0.2s;
        display: flex;
        align-items: center;
        justify-content: center;
        width: ${ARROW_SIZE}px;
        height: ${ARROW_SIZE}px;
        border-radius: ${ARROW_SIZE}px;
        background-color: ${(props) => (props.theme.color.night2 ? props.theme.color.night2 : '#10162D')};
        color: ${(props) => props.theme.color.white};
    }

    .left.down,
    .right.down {
        background-color: ${(props) => props.theme.color.primary};
        color: ${(props) => props.theme.color.white};
    }
`;
